<template>
    <div>
        <form style="width: 100%" >
            <CRow class="mb-3 ml-2">
                <h3>대상자정보 건별등록</h3>
            </CRow>
            <form style="width: 100%">
                <CRow>
                    <CCol md="6">
                        <CCard>
                            <CCardHeader>
                                <strong>대상자정보</strong>
                            </CCardHeader>
                            <CCardBody>
                                <CForm>
                                    <CInput
                                            label="이름"
                                            description="대상자이름을 입력해주세요"
                                            placeholder="대상자이름"
                                            horizontal
                                            required
                                            was-validated
                                            v-model="name"
                                            maxlength="5"
                                    />
                                    <CInput
                                            label="진료번호"
                                            placeholder="진료번호를 입력해주세요"
                                            description="대상자진료번호"
                                            horizontal
                                            required
                                            was-validated
                                            v-model="registNo"
                                            maxlength="20"
                                    />
                                    <div>
                                    <CInput
                                            label="주민번호"
                                            placeholder="주민번호 앞자리를 입력해주세요(ex: 887711)"
                                            description="대상자주민번호"
                                            horizontal
                                            required
                                            was-validated
                                            v-model="citizenNo"
                                            maxlength="6"
                                    />
                                </div>
                                    <!--<datetime type="datetime" v-model="datetime12" use12-hour></datetime>-->
                                    <div role="group" class="form-group was-validated form-row">
                                        <label for="uid-dq9zl88hwf8" class="col-form-label col-sm-3"> 입원일 </label>
                                        <div class="col-sm-9">
                                            <input id="uid-dq9zl88hwf8" type="date" required="required" class="form-control" min="2000-01-02" max="2999-12-31" v-model="inDate">
                                            <small class="form-text text-muted w-100">대상자입원일</small>
                                        </div>
                                    </div>
                                    <div role="group" class="form-group was-validated form-row">
                                        <label for="uid-dq9zl88hwf8" class="col-form-label col-sm-3"> 메모 </label>
                                        <div class="col-sm-9">
                                            <textarea style=" line-height: 4.8;" class="form-control" placeholder="메모를 입력하세요"  v-model="memo"></textarea>
                                            <small class="form-text text-muted w-100">메모</small>
                                        </div>
                                    </div>
                                </CForm>
                            </CCardBody>
                            <CCardFooter>
                                <CButton type="button" size="sm" color="primary"   @click="submit"><CIcon name="cil-check-circle"/> 저장</CButton>
                                <!--<button label="" type="button" class="btn btn btn-info" style="text-align: right; margin-left: 10px;"   @click="back"> 닫기 </button>-->
                                <CButton type="button" size="sm" color="primary" style="margin-left: 10px;"   @click="back"><CIcon name="cil-check-circle"/> 닫기</CButton>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </form>
        </form>
    </div>
</template>
<style>
    .btn-col-margin{
        margin-top: 5px;
        margin-left: 15px;
        margin-right: 10px;
    }
    .col-title{
        width: 20%;
    }
</style>
<script>

    import Vue from 'vue'
    import CTableWrapper from "../base/PayManageInsertForm";
    import Table from "../base/Table";
    import ButtonGroups from "../buttons/ButtonGroups";
    import 'url-search-params-polyfill';
    import axios from 'axios'
    import VueMoment from 'vue-moment'


    Vue.use(VueMoment)
    /*import Datetime from 'vue-datetime'*/
    /*import 'vue-datetime/dist/vue-datetime.css'*/

    /*Vue.use(Datetime)*/

    export default {
        name: 'PayManageInsertForm',
        components: {ButtonGroups, Table, CTableWrapper},
        data() {
            return{
                name: '',
                registNo: '',
                citizenNo:'',
                inDate: this.$moment().add('d') .format('YYYY-MM-DD'),
                memo: '',
            }
        },
        methods: {

            submit () {
                if(this.name == "") {
                    alert("이름을 입력해주세요");
                    return;
                }
                if(this.registNo == "") {
                    alert("진료번호를을 입력해주세요");
                    return;
                }
                if(this.registNo == "") {
                    alert("주민번호(앞자리6자리)를을 입력해주세요");
                    return;
                }

                axios.post('/silver/cust/custInsert', {
                    name: this.name,
                    registNo: this.registNo,
                    citizenNo: this.citizenNo ,
                    inDate: this.inDate,
                    memo: this.memo,
                    json:true
                })
                    .then(data => {
                        this.$router.push({name:"paymanagementlist"})
                    })
                    .catch(function (error) {
                        console.log(error);
                        alert("서버에러");

                    });
            },
            back() {
                this.$router.push({name:"paymanagementlist"})
            }
        },
        computed: {

        }
    }
</script>
